import { ReactComponent as InformaPingLogo } from '../../../../../assets/images/informaconnect/informa-ping-logo.svg';
import { Anchor } from '../../../../shared/Anchor';
import styles from './index.module.scss';

export default function Brand() {
  return (
    <div className={styles.brand}>
      <Anchor to="https://www.informa.com/" openInNewTab={false}>
        <InformaPingLogo />
      </Anchor>
    </div>
  );
}
